import styled, { createGlobalStyle } from 'styled-components';
import { rgba, lighten } from 'polished';
import { px2rem } from '../../helpers/rem.mjs';
import { MEDIA_QUERY } from '../../constants/responsive.mjs';

var Wrapper = styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1i3qbz1-0"
})(["position:relative;max-width:100%;"]);
var VideoContainer = styled.video.withConfig({
  displayName: "VideoContainer",
  componentId: "sc-1i3qbz1-1"
})(["width:100%;height:100%;background-color:", ";"], function (props) {
  return props.theme.colorV2.colorSet.white1000;
});
var PipWrapper = styled.div.withConfig({
  displayName: "PipWrapper",
  componentId: "sc-1i3qbz1-2"
})(["cursor:pointer;position:absolute;bottom:", ";right:", ";"], px2rem(8), px2rem(8));
styled.button.withConfig({
  displayName: "PipButton",
  componentId: "sc-1i3qbz1-3"
})(["width:", ";height:", ";"], px2rem(32), px2rem(32));
styled.canvas.withConfig({
  displayName: "Blurhash",
  componentId: "sc-1i3qbz1-4"
})(["position:absolute;top:0;left:0;bottom:0;right:0;width:100%;height:100%;z-index:", ";"], function (props) {
  return props.theme.zIndexes.below;
});
var ToggleVeil = styled.div.attrs({
  role: "button"
}).withConfig({
  displayName: "ToggleVeil",
  componentId: "sc-1i3qbz1-5"
})(["width:100%;height:100%;position:absolute;inset:0;z-index:", ";"], function (props) {
  return props.theme.zIndexes["default"] + 1;
});
var VolumeControl = styled.button.withConfig({
  displayName: "VolumeControl",
  componentId: "sc-1i3qbz1-6"
})(["font-family:VideoJS;font-weight:normal;font-style:normal;position:absolute;width:", ";height:", ";bottom:", ";right:", ";color:white;font-size:", ";line-height:", ";z-index:", ";:before{content:", ";}@media ", "{transition:150ms background-color ease-in-out;:hover{background-color:", ";}}"], px2rem(32), px2rem(32), px2rem(8), px2rem(8), px2rem(24), px2rem(24), function (props) {
  return props.theme.zIndexes["default"] + 2;
}, function (props) {
  return props.muted ? "\"\f104\"" : "\"\f107\"";
}, MEDIA_QUERY.EXCEPT_MOBILE, function (props) {
  return props.theme.colorV2.colorSet.grey200;
});
var CenterPlayButton = styled.button.withConfig({
  displayName: "CenterPlayButton",
  componentId: "sc-1i3qbz1-7"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:block;visibility:hidden;z-index:", ";width:", ";height:", ";border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:", ";box-shadow:", " 0px 0px 10px;background-color:", ";color:white;font-family:VideoJS;font-weight:normal;font-style:normal;:before{content:", ";}@media ", "{width:", ";height:", ";font-size:", ";}"], function (props) {
  return props.theme.zIndexes["default"];
}, px2rem(70), px2rem(70), px2rem(36), function (props) {
  return props.theme.colorV2.colorSet.grey300;
}, function (props) {
  return props.theme.colorV2.colorSet.grey300;
}, function (props) {
  return props.playStatus ? "\"\f103\"" : "\"\f101\"";
}, MEDIA_QUERY.ONLY_MOBILE, px2rem(36), px2rem(36), px2rem(24));
var VideoJsGlobalStyle = createGlobalStyle([".video-js.vjs-has-started:not(.vjs-controls-disabled) + ", "{transform:translateY(-", ");transform:translate3d(0,-", ",0);}.video-js.vjs-has-started.vjs-user-inactive.vjs-playing + ", "{transform:translateY(0);transform:translate3d(0,0,0);transition:transform 1.2s;}.vjs-fullscreen + ", "{display:none;}.video-js{font-size:", " !important;color:", " !important;}.vjs-default-skin .vjs-big-play-button{font-size:2.75em !important;line-height:2em !important;height:2em !important;width:2em !important;color:", " !important;border:0.06666em solid ", " !important;border-radius:50% !important;left:50% !important;top:50% !important;margin-left:-1em !important;margin-top:-1em !important;}.video-js .vjs-control-bar,.video-js .vjs-menu-button .vjs-menu-content{background-color:", " !important;}.vjs-mouse-display{display:none;}.vjs-menu-item-text{color:", " !important;}.vjs-menu-button{font-size:1em;line-height:3em;}.vjs-menu li.vjs-selected,.vjs-menu li.vjs-selected:focus,.vjs-menu li.vjs-selected:hover{background-color:", " !important;color:", " !important}.vjs-control-bar::before{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;background-color:", ";}.video-js .vjs-big-play-button{background-color:", " !important;}.video-js:hover .vjs-big-play-button,.video-js .vjs-big-play-button:focus{background-color:", " !important;}.video-js .vjs-load-progress,.video-js .vjs-load-progress div,.video-js .vjs-slider{background-color:", " !important;}.video-js .vjs-volume-level,.video-js .vjs-play-progress,.video-js .vjs-slider-bar{background:", " !important;}.vjs-poster{img{width:100%;height:100%;}}:not(:root):fullscreen,.vjs-fullscreen > video{object-fit:contain !important;}.playButtonAnim-enter-active,.playButtonAnim-exit-active{animation:PlayAnim 600ms ease-in-out;}@keyframes PlayAnim{0%{visibility:visible;opacity:0.7;transform:scale(1) translate(-50%,-50%);}50%{opacity:1;}100%{opacity:0.2;transform:scale(1.2) translate(-42%,-42%);}}"], PipWrapper, px2rem(30), px2rem(30), PipWrapper, PipWrapper, px2rem(10), function (props) {
  return props.theme.colorV2.colorSet.grey300;
}, function (props) {
  return props.theme.colorV2.colorSet.white1000;
}, function (props) {
  return props.theme.colorV2.colorSet.white1000;
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.white1000, 0.9);
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.grey1000, 0.9);
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.white800, 0.9);
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.white800, 0.2);
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.white1000, 0.9);
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.grey800, 0.2);
}, function (props) {
  return rgba(props.theme.colorV2.colorSet.grey800, 0.2);
}, function (props) {
  return rgba(lighten(0.9, props.theme.colorV2.colorSet.grey50), 0.9);
}, function (props) {
  return props.theme.colorV2.colorSet.grey300;
});

export { CenterPlayButton, PipWrapper, ToggleVeil, VideoContainer, VideoJsGlobalStyle, VolumeControl, Wrapper };
